enum REQUEST_IDS {
  GET_SYMBOLS = 'getSymbols',
  SUBSCRIBE_TICKER = 'subscribeTicker',
}

export default REQUEST_IDS;
